module.exports = __webpack_public_path__ + "img/g3.26269c92.jpg";